import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SelectAllotmentPage } from './select-allotment.page';

const routes: Routes = [
  { path: '', component: SelectAllotmentPage }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SelectAllotmentRoutingModule { }
